var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#050404",
    fillOpacity: 0.986,
    d: "M -0.5,-0.5 C 7.5,-0.5 15.5,-0.5 23.5,-0.5C 23.5,7.5 23.5,15.5 23.5,23.5C 15.5,23.5 7.5,23.5 -0.5,23.5C -0.5,15.5 -0.5,7.5 -0.5,-0.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#91d5d9",
    d: "M 14.5,2.5 C 13.1667,6.5 11.8333,10.5 10.5,14.5C 11.436,10.2648 11.7693,5.93147 11.5,1.5C 12.791,1.26269 13.791,1.59603 14.5,2.5 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90263e",
    d: "M 17.5,5.5 C 18.404,6.20895 18.7373,7.20895 18.5,8.5C 17.5,8.5 16.5,8.5 15.5,8.5C 15.6621,10.5273 15.4955,12.5273 15,14.5C 14.5831,15.756 13.7498,16.4226 12.5,16.5C 14.1264,13.7543 14.7931,10.7543 14.5,7.5C 16.1788,7.71481 17.1788,7.04814 17.5,5.5 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8dde1",
    d: "M 14.5,2.5 C 15.2719,3.69354 16.2719,4.69354 17.5,5.5C 17.1788,7.04814 16.1788,7.71481 14.5,7.5C 14.7931,10.7543 14.1264,13.7543 12.5,16.5C 6.80597,17.9815 4.30597,15.6482 5,9.5C 6.10963,7.96317 7.60963,7.2965 9.5,7.5C 9.08049,9.09362 8.41382,10.5936 7.5,12C 7.56993,12.7648 7.90326,13.2648 8.5,13.5C 8.84171,14.3382 9.50838,14.6716 10.5,14.5C 11.8333,10.5 13.1667,6.5 14.5,2.5 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#91273f",
    d: "M 9.5,7.5 C 10.0967,7.7352 10.4301,8.2352 10.5,9C 9.58618,10.4064 8.91951,11.9064 8.5,13.5C 7.90326,13.2648 7.56993,12.7648 7.5,12C 8.41382,10.5936 9.08049,9.09362 9.5,7.5 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M 4.5,18.5 C 9.16667,18.5 13.8333,18.5 18.5,18.5C 18.5,19.5 18.5,20.5 18.5,21.5C 15.6062,21.9577 13.1062,21.291 11,19.5C 9.24583,21.25 7.07917,21.9167 4.5,21.5C 4.5,20.5 4.5,19.5 4.5,18.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.64021173f0468e5227c7fafd0892d279.svg";
export { ForwardRef as ReactComponent };